module.exports = __webpack_public_path__ + "img/heart@2x(1).a740c15e.png";